import { notify } from '@/utils/notify'
import store from '@/store'
import { USER_RPT_PROCESS } from '@/store/types'
const SockJS = require('sockjs-client/dist/sockjs.js')
const Stomp = require('stompjs')
const debugMode = process.env.VUE_APP_DEBUGMODE

let stompClient

export function initStompClient() {
  try {
    if (store.state.app.wsLink) {
      const wsUrl = process.env.VUE_APP_APIURL + store.state.app.wsLink
      const headers = {
        'x-auth-token': store.state.token.token
      }

      connectAndReconnect(wsUrl, headers, 1)
    }
  } catch (err) {
    console.log(err)
    stompClient = undefined
  }
}

const connectAndReconnect = (wsUrl, headers) => {
  let sock = new SockJS(wsUrl)
  stompClient = Stomp.over(sock)
  stompClient.debug = function (str) {
    // Switch this off in production (maybe we can have a flag for production mode)
    if (debugMode !== undefined && debugMode === true) {
      console.log(str + '\n')
    }
  }
  stompClient.connect(headers, function (frame) {
    successfulCallback()
  }, (err) => {
    if (err && err.command && err.command === 'ERROR') {
      // If its error, skip retrying. Most likely token has timeout/expired
    } else {
      // https://github.com/jmesnil/stomp-websocket/issues/81
      // Error Call Back (To reconnect it after disconnecting)
      // Retry every 10 secs
      setTimeout(() => {
        if (debugMode !== undefined && debugMode === true) {
          console.log('Attempting to reconnect to WS')
        }
        connectAndReconnect(wsUrl, headers)
      }, 10000)
    }
  })
}

/**
 * Called when websocket is successfully connected
 */
const successfulCallback = () => {
  // https://github.com/jhipster/generator-jhipster/issues/1370

  // Destination subscription done here
  const notificationLink = store.state.app.wsSubscribe.notification
  if (notificationLink) {
    stompClient.subscribe(notificationLink, function (message) {
      // showMessageOutput(JSON.parse(message.body))
      const parsedMessage = JSON.parse(message.body)
      if (parsedMessage && parsedMessage.newNotificationCount !== undefined && parsedMessage.newNotificationCount > 0) {
        store.dispatch('initNotification')
        notify('You have a new Notification')
      }
    })
  } else {
    console.error('Unable to subscribe to notification')
  }

  const reportLink = store.state.app.wsSubscribe.report
  if (reportLink) {
    stompClient.subscribe(reportLink, function (message) {
      const parsedMessage = JSON.parse(message.body)
      store.commit(USER_RPT_PROCESS, parsedMessage)
    })
  } else {
    console.error('Unable to subscribe to report')
  }
}

// const checkConnected = (resolve, reject, tries) => {
//   if (stompClient) {
//     if (tries < 10) {
//       if (stompClient.connected) {
//         resolve(stompClient)
//       } else {
//         setTimeout(function () {
//           console.log(tries)
//           tries++
//           checkConnected(resolve, reject, tries)
//         }, 5000)
//       }
//     }
//     if (tries >= 10) {
//       reject(new Error('Fail to init websocket (not connected)'))
//       stompClient = undefined
//     }
//   } else {
//     // By this point, stompClient cannot be null (at most not connected)
//     reject(new Error('Fail to init websocket (empty client)'))
//   }
// }

function getStompClient() {
  return new Promise((resolve, reject) => {
    if (!stompClient) {
      initStompClient()
      // checkConnected(resolve, reject, 0)
    } else {
      // checkConnected(resolve, reject, 0)
    }
  })
}

export default getStompClient
